import request from '@/utils/request';

/**
 *  流程审核接口
 */
export function ExamineApi () {
  return {
    //审核-审核列表
    getWorkflowList: params => {
      return request ({
        url: '/admin/workflow/index',
        method: 'get',
        params,
      });
    },
    //审核-审核详情
    getWorkflowDetil: params => {
      return request ({
        url: `/admin/workflow/show?id=${params}`,
        method: 'get',
        data: params,
      });
    },
    //审核-发起审核
    setWorkflowStore: params => {
      return request ({
        url: '/admin/workflow/store',
        method: 'post',
        data: params,
      });
    },
    // //审核-重新提审--废弃
    // setWorkflowRestore: params => {
    //   return request ({
    //     url: '/admin/workflow/restore',
    //     method: 'post',
    //     data: params,
    //   });
    // },
    //审核-上传附件
    uploadAttachments: data => {
      return request({
          url: '/admin/upload/attachments',
          method: 'post',
          data,
      });
    },

    //费用类型-费用类型列表
    getExpenseTypeList: params => {
      return request ({
        url: '/admin/expense/type/index',
        method: 'get',
        params,
      });
    },
    //费用类型-费用类型详情
    getExpenseTypeDetail: params => {
      return request ({
        url: `/admin/expense/type/show?id=${params}`,
        method: 'get',
        data: params,
      });
    },
    //费用类型-添加
    getExpenseTypeAdd: params => {
      return request ({
        url: '/admin/expense/type/store',
        method: 'post',
        data: params,
      });
    },
    //费用类型-编辑
    getExpenseTypeEdit: params => {
      return request ({
        url: '/admin/expense/type/update',
        method: 'post',
        data: params,
      });
    },
    //费用类型-选择器
    getExpenseTypeSelect: params => {
      return request ({
        url: '/admin/expense/type/select',
        method: 'get',
        data: params,
      });
    },
  };
}
